export default {
  active: '激活账户',
  send: '我们会发送短信到您的手机账号',
  phone: '手机号',
  enterCode: '输入验证码',
  sendAgain: '再次发送',
  enterNewPassword: '输入新密码',
  reEnterNewPassword: '再次输入密码',
  activate: '激活',
}
